import { PagesReducers } from './pages/pages-reducers.ts'

export const Reducers = {
  ...PagesReducers
}
